import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'rmt-tile-new',
  templateUrl: 'rmt-tile-new.html'
})
export class RmtTileNewComponent {

  /*
    Example to use this.
    
    Tile with Two section  
    
    <rmt-tile-new style="margin-top: 100px;width: 100% !important;" (onTileSelected)="onTileSelected($event, tile)"  [tileWithTwoSections]="true" [sectionOneTitle]="'Unlimited Social'"
          [sectionOneSubTitle]="'10GB data can be used in Singapore & Malaysia'" [sectionOneInformationText] = "'Valid for 7 days'"
          [sectionTwoTitle]="'102'" [sectionTwoSubTitle]="'F CFA'" [canDisableTile]="false" [isTileSelected]="true"></rmt-tile-new>

    Tile with One sections
    
    <rmt-tile-new style="margin-top: 100px;width: 100% !important;" (onTileSelected)="onTileSelected($event, tile)"  [tileWithTwoSections]="false" 
        [sectionTwoTitle]="'102'" [sectionTwoSubTitle]="'F CFA'" [canDisableTile]="false" [isTileSelected]="true"></rmt-tile-new>
  */
  /*
    This is to use when we need a bigger tile with two different sections.
  */ 
  @Input() tileWithTwoSections: boolean = false;
  /*
    This is to apply the selection style  on the tile.
  */ 
  @Input() isTileSelected: boolean = true;

  /**
    This is for section one title.
   */
  @Input() sectionOneTitle: string = "";
  /*
    This is fot section one sub title.
   */
  @Input() sectionOneSubTitle: string = "";
  /**
    This is for section one informationational text.
   */
  @Input() sectionOneInformationText: string = "";
  /*
    This is for section two title
   */
  @Input() sectionTwoTitle: string = "";
  /*
    This is for section two sub tile
   */
  @Input() sectionTwoSubTitle: string = "";
  /*
    This is for section two sub tile
   */
    @Input() canDisableTile: boolean = false;
  /*
     we can ignore if we can handle it local to the page.
  */
  @Output() onTileSelected: EventEmitter<any> = new EventEmitter();
  @Input() isNewUI: boolean = false;
  @Input() tileInfo = [];
  constructor() {
  }

  onTileDivSelected($event){
    if(!this.canDisableTile){
      this.onTileSelected.emit($event);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-tile-new/rmt-tile-new.ts